import {codexModes, priorities, requestTypes} from "./product-brief-schema";

export const DEFAULT_PROMPT_RULES_PATH = "./docs/prompts/codex-prompt-core-rules.md";

// این فایل مرجع قابل ویرایش قوانین Prompt است.
// متن آن در زمان تولید Prompt تنها وقتی جایگزین قواعد پیش‌فرض می‌شود
// که صفحه آن را به‌صورت `brief.promptRulesText` به این Utility پاس بدهد.


const TECHNICAL_IMPLEMENTATION_RULES = [
    "## استانداردهای اجباری پیاده‌سازی Frontend",
    "",
    "### Context و مستندات پروژه",
    "- پیش از شروع، مستندات موجود پروژه را بخوان؛ به‌خصوص Frontend Context Pack، Route and Page Map، Component Catalog، Frontend API Usage و Feature Status.",
    "- تمام صفحه‌ها، Routeها، فایل‌ها و ساختار Feature جدید باید مطابق مستندات موجود در docs پروژه ایجاد یا به‌روزرسانی شوند.",
    "- پیش از ساخت هر Component، Component Catalog و Componentهای موجود پروژه را بررسی کن.",
    "- هرجا Component قابل استفاده‌ی فعلی وجود دارد، همان Component را reuse کن و Component تکراری نساز.",
    "",
    "### PrimeReact",
    "- تمام Componentهای ساده و ترکیبی موردنیاز باید با PrimeReact ساخته شوند.",
    "- برای کنترل‌های تعاملی اصلی از HTML خام مانند `input`، `select`، `textarea`، `button`، `checkbox`، `dialog`، `dropdown`، `tooltip`، `table`، `calendar` یا `multi-select` استفاده نکن؛ مگر اینکه بعد از بررسی واقعی مشخص شود PrimeReact معادل مناسب ندارد.",
    "- برای فرم‌ها و کنترل‌ها تا حد امکان از Componentهای PrimeReact استفاده کن؛ از جمله:",
    "  - Dialog",
    "  - Button",
    "  - InputText",
    "  - InputTextarea",
    "  - Dropdown",
    "  - MultiSelect",
    "  - Calendar",
    "  - Checkbox",
    "  - InputSwitch",
    "  - InputNumber",
    "  - Chips",
    "  - Tooltip",
    "  - Divider",
    "  - Card",
    "  - Panel",
    "  - TabView",
    "  - Accordion",
    "  - DataTable",
    "  - Message",
    "  - Toast",
    "  - ConfirmDialog",
    "  - Skeleton",
    "  - ProgressSpinner",
    "- Component جدید فقط در صورت نیاز واقعی ساخته شود.",
    "- Componentهای جدید، چه ساده و چه ترکیبی، باید reusable، typed، دارای مسئولیت مشخص و Props شفاف باشند.",
    "- Component جدید نباید به یک صفحه یا سناریوی خاص به‌صورت سخت‌کد وابسته باشد.",
    "- Component جدید باید از منطق API، Route و داده‌ی اختصاصی صفحه جدا باشد.",
    "- Componentهای Feature-specific داخل پوشه همان Feature قرار بگیرند.",
    "- Componentهایی که واقعاً در بیش از یک بخش محصول قابل استفاده‌اند، طبق مستندات پروژه به Shared Components منتقل شوند.",
    "- هیچ Component تکراری با مسئولیت مشابه ایجاد نکن.",
    "",
    "### PrimeReact Styling و Pass Through",
    "- برای رنگ‌ها، Styleها، Spacing و classNameها ابتدا فقط از کلاس‌ها، Tokenها، Utility Classها و الگوهای موجود PrimeReact و ساختار فعلی پروژه استفاده کن.",
    "- از ساخت رنگ‌های جدید، کلاس‌های پراکنده، Inline Styleهای غیرضروری و CSS اختصاصی بدون بررسی Design System پروژه خودداری کن.",
    "- اگر برای شخصی‌سازی یک Component از PrimeReact نیاز وجود دارد، ابتدا از قابلیت Pass Through یا `pt` خود PrimeReact استفاده کن.",
    "- برای Customizationهای PrimeReact، از API رسمی Component، `className`، `style`، `icon`، `template` و `pt` استفاده کن.",
    "- ساختار DOM داخلی Componentهای PrimeReact را با CSS شکننده Override نکن.",
    "- فقط در صورت نبود راه رسمی، CSS محدود، مستند و قابل نگهداری اضافه کن.",
    "",
    "### Translation و متن‌های رابط کاربری",
    "- تمام Labelها، Titleها، Descriptionها، Placeholderها، Tooltipها، Validation Messageها، Button Textها، Toastها، Warningها، Empty Stateها، Error Stateها و متن‌های Preview باید با hook فعلی `useTranslate` مدیریت شوند.",
    "- تمام Translation Keyهای جدید باید در `public/languages/fa.json` ثبت شوند.",
    "- هیچ متن قابل مشاهده‌ای به فارسی یا انگلیسی نباید داخل JSX، Component یا Utility به‌صورت Hardcode باقی بماند.",
    "- پیش از ایجاد Translation Key جدید، فایل `public/languages/fa.json` را بررسی کن تا Key مشابه و تکراری ساخته نشود.",
    "- Translation Keyها باید معنادار، دسته‌بندی‌شده و قابل نگهداری باشند.",
    "- نمونه ساختار مناسب برای کلیدها:",
    "  - reports.builder.title",
    "  - reports.builder.chartEntity.label",
    "  - reports.builder.chartEntity.placeholder",
    "  - reports.builder.validation.metricRequired",
    "  - reports.builder.emptyPreview.title",
    "",
    "### Chart.js",
    "- تمام نمودارهای Preview باید با Chart.js ساخته شوند.",
    "- اگر در پروژه PrimeReact Chart از قبل وجود دارد یا با نسخه فعلی PrimeReact سازگار است، از همان PrimeReact Chart که بر پایه Chart.js کار می‌کند استفاده کن.",
    "- ابتدا `package.json` و Integration فعلی پروژه را بررسی کن تا اگر `chart.js`، `react-chartjs-2` یا PrimeReact Chart وجود دارد، همان الگو Reuse شود.",
    "- هیچ کتابخانه نمودار دیگری اضافه نکن.",
    "- Chart Renderer باید از Report Config و Mock Data Provider جدا باشد.",
    "- Mock Data فقط در لایه Preview استفاده شود و وارد API یا State اصلی محصول نشود.",
    "- تنظیمات Chart.js باید بر اساس Entity، Chart Style، Metric، Group By و Annotation به‌صورت Config-Driven ساخته شوند.",
    "- Pluginهای Chart.js فقط پس از بررسی و Registration یک‌دست استفاده شوند.",
    "- برای Chart Styleهایی که Chart.js به‌صورت پیش‌فرض پشتیبانی نمی‌کند، مانند Lollipop، ابتدا امکان اجرای استاندارد و کم‌ریسک بررسی شود.",
    "- اگر اجرای Lollipop با Chart.js و Pluginهای موجود ممکن نیست، آن را به‌عنوان `Decision Required` ثبت کن و راه‌حل خیالی نساز.",
    "",
    "### Page و Route",
    "- هر Page یا Route جدید باید دقیقاً طبق مستندات پروژه ساخته شود.",
    "- پیش از ایجاد یا تغییر Route، این موارد را بررسی کن:",
    "  - `docs/frontend-context/02-route-and-page-map.md`",
    "  - `docs/frontend-context/04-component-catalog.md`",
    "  - `public/application.json`",
    "  - `src/App.*`",
    "  - `src/pages/index.*`",
    "  - `public/languages/fa.json`",
    "- Route جدید باید مطابق الگوی فعلی پروژه در `application.json` و `pagesMap` ثبت شود.",
    "- نام Route و Page باید یکتا باشد.",
    "- Translation مربوط به Title و Description صفحه باید اضافه شود.",
    "- Toolbar، Sidebar و `show-in-sidebar` باید آگاهانه و مطابق مستندات تنظیم شوند.",
    "- Permission جدید اختراع نکن.",
    "",
    "### State، UX و کیفیت",
    "- State باید قابل فهم، قابل تست و تا حد امکان Config-Driven باشد.",
    "- از شرط‌های عمیق و پراکنده در JSX پرهیز کن.",
    "- UI باید RTL، فارسی، Responsive و هماهنگ با الگوهای فعلی زوفینو باشد.",
    "- حالت‌های Loading، Empty، Error، Validation Error، Disabled و No Permission باید برای Feature بررسی و در صورت نیاز پیاده‌سازی شوند.",
    "- UI Visibility را معادل Backend Authorization فرض نکن.",
    "- هیچ Endpoint، Field، Relation یا API Contract جدیدی را بدون Evidence یا Backend Receipt تأییدشده فرض نکن.",
    "- در پایان، مستندات مرتبط با Route، Component Catalog، Feature Status و Riskها را به‌روزرسانی کن.",
].join("\n");

const MODE_INSTRUCTIONS = {
    analysis: [
        "هیچ کد محصولی تغییر نده.",
        "فقط تحلیل کن، Component Catalog، Route and Page Map، Translation Structure، PrimeReact patterns، Pass Through usage، Chart.js Integration و وضعیت Backend را بررسی کن.",
        "Componentهای قابل reuse را مشخص کن.",
        "اگر Backend برای این فیچر کافی نیست، BCR بساز.",
    ].join(" "),
    "frontend-after-receipt": [
        "فقط Endpointها، Fieldها، Relationها و Permissionهایی را مصرف کن که در Backend Receipt یا API Contract تأیید شده‌اند.",
        "تمام کنترل‌های UI با PrimeReact ساخته شوند.",
        "برای شخصی‌سازی PrimeReact ابتدا از Pass Through یا `pt` استفاده کن.",
        "تمام متن‌های رابط کاربری با `useTranslate` و `public/languages/fa.json` مدیریت شوند.",
        "تمام نمودارهای Preview با Chart.js یا PrimeReact Chart مبتنی بر Chart.js ساخته شوند.",
    ].join(" "),
    "ui-only": [
        "مدل داده، API Contract، Permission، Route و Backend behavior را تغییر نده.",
        "فقط UX و UI را در محدوده مشخص بهبود بده.",
        "از PrimeReact و Componentهای Reusable موجود استفاده کن.",
        "برای Customization ابتدا از Pass Through یا `pt` استفاده کن.",
        "همه متن‌های جدید را از طریق `useTranslate` و `public/languages/fa.json` اضافه کن.",
    ].join(" "),
    bugfix: [
        "ابتدا باگ را بازتولید کن، Source of Truth را پیدا کن، اثر تغییر را بررسی کن و کوچک‌ترین اصلاح امن را انجام بده.",
        "در صورت تغییر UI، از PrimeReact استفاده کن.",
        "در صورت نیاز به Customize کردن PrimeReact، ابتدا از Pass Through یا `pt` استفاده کن.",
        "در صورت اضافه‌شدن متن جدید، Translation Key مناسب به `public/languages/fa.json` اضافه کن.",
        "در صورت مرتبط‌بودن با Chart، فقط Chart.js Integration موجود را اصلاح کن.",
    ].join(" "),
};

export function buildProductBriefText(brief = {}, translate = (key) => key) {
    const technicalNotes = brief.technicalNotes || {};

    const lines = [
        "# برگه محصول",
        "",
        section("اطلاعات پایه", [
            field("نوع درخواست", optionLabel(requestTypes, brief.requestType, translate)),
            field("نام فیچر یا تغییر", brief.featureName),
            field("اولویت", optionLabel(priorities, brief.priority, translate)),
            field("بخش‌های درگیر", brief.involvedAreas),
            field("درخواست‌دهنده", brief.requester),
            field("تاریخ ثبت", brief.requestDate),
            field("حالت اجرای Codex", optionLabel(codexModes, brief.codexMode, translate)),
        ]),
        section("مسئله و کاربر", [
            field("مسئله", brief.problem),
            field("کاربر هدف", brief.targetUser),
            field("نقش کاربر هدف", brief.targetRole),
            field("اثر کسب‌وکاری", brief.businessImpact),
            field("ارتباط با محصول فعلی", brief.existingProductRelation),
        ]),
        section("سناریو و دسترسی", [
            listField("سناریوی کاربر", brief.userScenario),
            roleTable("نقش‌های مجاز", brief.allowedRoles, ["role", "action", "description"]),
            roleTable("نقش‌های غیرمجاز", brief.deniedRoles, ["role", "limitation", "description"]),
            field("محل استفاده در محصول", brief.productLocation),
        ]),
        section("نتیجه و معیار پذیرش", [
            field("نتیجه نهایی مورد انتظار", brief.expectedOutcome),
            listField("معیارهای پذیرش", brief.acceptanceCriteria),
            listField("اتصال به بخش‌های محصول", brief.connectedAreas),
        ]),
        section("مرزها و ابهام‌ها", [
            listField("خارج از Scope", brief.outOfScope),
            listField("ابهام‌ها و تصمیم‌های باز", brief.openQuestions),
            field("وابستگی‌ها یا قابلیت‌های مرتبط موجود", brief.dependencies),
            field("Backend Receipt", technicalNotes.backendReceiptPath),
            field("BCR موجود", technicalNotes.bcrPath),
            field("Endpoint یا Contract شناخته‌شده", technicalNotes.knownEndpointOrContract),
            field("توضیحات فنی اضافه", technicalNotes.extraNotes),
        ]),
    ];

    return lines.filter(Boolean).join("\n");
}

export function buildCodexPrompt(brief = {}, translate = (key) => key) {
    const modeInstruction = MODE_INSTRUCTIONS[brief.codexMode] || "حالت اجرای Codex مشخص نشده است.";
    const technicalRules = String(brief.promptRulesText || TECHNICAL_IMPLEMENTATION_RULES).trim();

    return [
        `# ${String(brief.featureName || "درخواست محصول").trim() || "درخواست محصول"}`,
        "",
        "## Feature Brief",
        buildProductBriefText(brief, translate),
        "",
        technicalRules,
        "",
        "## Editable Prompt Rules Reference",
        `- قوانین اصلی و قابل ویرایش Prompt در مسیر: \`${DEFAULT_PROMPT_RULES_PATH}\` قرار دارند.`,
        "- پیش از اجرای درخواست، این فایل را بخوان و فقط در صورتی از متن جایگزین استفاده کن که Product Brief Builder آن را در `brief.promptRulesText` ارسال کرده باشد.",
        "",
        "## Required Codex Workflow",
        "- Context Pack و Shared Contracts را بخوان.",
        "- پیش از ساخت Component جدید، Component Catalog را بررسی کن.",
        "- پیش از ایجاد یا تغییر Route، Route and Page Map، `application.json` و `pagesMap` را بررسی کن.",
        "- پیش از اضافه‌کردن متن جدید، `public/languages/fa.json` را بررسی و Translation Key مناسب ایجاد کن.",
        "- تمام UI Textها را با `useTranslate` پیاده‌سازی کن.",
        "- برای UI و فرم‌ها از PrimeReact استفاده کن.",
        "- برای شخصی‌سازی PrimeReact ابتدا از Pass Through یا `pt` استفاده کن.",
        "- برای رنگ‌ها، Styleها و classNameها از کلاس‌ها و الگوهای موجود PrimeReact و پروژه استفاده کن.",
        "- پیش از اضافه‌کردن Chart dependency، `package.json` و Integration فعلی Chart.js یا PrimeReact Chart را بررسی کن.",
        "- نمودارها را با Chart.js یا PrimeReact Chart مبتنی بر Chart.js پیاده‌سازی کن.",
        "- UI visibility را authorization backend فرض نکن.",
        "- اگر Backend Contract کافی نیست، کد محصول جدید نساز و BCR ایجاد کن.",
        "- اگر Backend Receipt تأییدشده وجود دارد، فقط براساس آن integration انجام بده.",
        "- loading، empty، error، no-permission، RTL و mobile را پوشش بده.",
        "- هر تصمیم مبهم را در Decision Log یا Conflict Register ثبت کن.",
        "- در پایان، مستندات مرتبط را به‌روزرسانی کن.",
        "",
        "## Mode-Specific Instruction",
        modeInstruction,
        "",
        "## Expected Output",
        "- Architecture summary",
        "- Files changed",
        "- PrimeReact components used",
        "- Existing reusable components reused",
        "- New reusable components created",
        "- PrimeReact Pass Through or `pt` customizations used",
        "- Translation keys added to `public/languages/fa.json`",
        "- Chart.js or PrimeReact Chart integration details",
        "- Route and page mapping changes",
        "- API contracts used",
        "- Permission behavior",
        "- Manual test scenarios",
        "- Documentation updates",
        "- Blockers and decisions",
    ].join("\n");
}

function section(title, content) {
    return [`## ${title}`, ...content.filter(Boolean), ""].join("\n");
}

function field(label, value) {
    const normalizedValue = String(value ?? "").trim();
    return `- ${label}: ${normalizedValue || "تکمیل نشده"}`;
}

function listField(label, items) {
    const values = (items || [])
        .map((item) => String(item ?? "").trim())
        .filter(Boolean);

    if (!values.length) {
        return `- ${label}: تکمیل نشده`;
    }

    return [`- ${label}:`, ...values.map((item) => `  - ${item}`)].join("\n");
}

function roleTable(label, items, keys) {
    const values = (items || [])
        .map((item) => {
            const row = keys
                .map((key) => String(item?.[key] ?? "").trim())
                .filter(Boolean);

            return row.length ? row : null;
        })
        .filter(Boolean);

    if (!values.length) {
        return `- ${label}: تکمیل نشده`;
    }

    return [
        `- ${label}:`,
        ...values.map((row) => `  - ${row.join(" | ")}`),
    ].join("\n");
}

function optionLabel(options = [], value, translate) {
    const item = options.find((option) => option.value === value);

    if (!item) {
        return value || "تکمیل نشده";
    }

    const translated = translate(item.labelKey);
    return translated && translated !== item.labelKey ? translated : item.labelKey;
}
